import { render, staticRenderFns } from "./MessageType.vue?vue&type=template&id=1ae259ad&"
import script from "./MessageType.vue?vue&type=script&lang=js&"
export * from "./MessageType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae259ad')) {
      api.createRecord('1ae259ad', component.options)
    } else {
      api.reload('1ae259ad', component.options)
    }
    module.hot.accept("./MessageType.vue?vue&type=template&id=1ae259ad&", function () {
      api.rerender('1ae259ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Notification/MessageType/MessageType.vue"
export default component.exports